<template>
    <div class="calendar-picker-reservation">
        <div class="header">{{ $t("calendar.reservationSidebarFilter") }}</div>
        <div class="search-wrapper">
            <a-input-search v-model:value="search" :placeholder="$t('message.inputSearchText')" />
        </div>
        <div class="list-item" v-for="myReservation in myReservations" @click="changeCalendar(myReservation._id)">
            {{ myReservation.title }}
        </div>
        <div class="group-title">{{ $t("calendar.agents") }}</div>
        <div class="list-items">
            <div
                class="list-item"
                v-for="reservation in getFilteredOtherReservations()"
                @click="changeCalendar(reservation._id)"
            >
                <AgentAvatar :size="25" :userID="reservation.userId._id" :font-size="15" />
                <span>{{ reservation.userId.name + " / " + reservation.title }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";
import { mapGetters, mapState } from "vuex";
import { CALENDAR_API } from "../../../../../api/calendar";

export default Vue.extend({
    name: "CalendarPickerReservation",
    components: {
        AgentAvatar,
    },
    props: {
        value: {
            type: String,
            default: "my",
        },
        reservationPlans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            search: "",
            clone: this.value,
            myReservations: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
        }),
        ...mapGetters({}),
    },
    methods: {
        changeCalendar(id) {
            this.clone = id;
        },
        getFilteredOtherReservations() {
            return this.reservationPlans.filter((item) => item.userId._id !== this.user._id);
        },
    },
    mounted() {
        console.log("CalendarPickerReservation work");
        this.myReservations = this.reservationPlans.filter((item) => item.userId._id === this.user._id);
    },
    watch: {
        value(val) {
            if (val !== this.clone) {
                this.clone = val;
            }
        },
        clone(val) {
            this.$emit("input", val);
        },
    },
});
</script>

<style scoped lang="scss">
.calendar-picker-reservation {
    display: flex;
    flex-direction: column;
    width: 300px;

    .header {
        display: flex;
        flex-flow: column;
        color: var(--color-text-strong-default);
        background-color: var(--color-bg-neutral-low-default);
        outline-style: none;
        cursor: default;
        justify-content: center;
        align-items: center;
        padding: 8px;
        width: 100%;
    }

    .search-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 20px;
    }

    .group-title {
        display: flex;
        flex-flow: column;
        color: var(--color-text-strong-default);
        background-color: var(--color-bg-neutral-low-default);
        outline-style: none;
        cursor: default;

        font-weight: 600;
        justify-content: left;
        text-align: left;
        text-transform: uppercase;
        padding: 8px 12px;
        font-size: 12px;
    }

    .list-item {
        display: flex;
        position: relative;
        padding: 8px 12px;
        cursor: pointer;
        transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        overflow-wrap: anywhere;
        background-color: var(--color-bg-default);
        font-size: 14px;
        font-weight: 500;
        color: var(--color-text-strong-default);
        align-items: center;
        gap: 5px;
        border-bottom: 1px solid var(--color-border-default);

        &:hover {
            background: var(--color-bg-hover);
        }
    }

    .list-items {
        overflow-y: auto;
        height: 200px;
    }
}
</style>
